import React, { useState, useEffect, useCallback } from "react";
import { Select, Table, Input, Button, Spin, Space } from "antd";
import api from "../../../api/index";
import moment from "moment";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import TotalInvoicesModal from "./Modal/TotalInvoicesModal/index";
import OneInvoiceModal from "./Modal/OneInvoiceModal/index";
import TotalPnlReportsModal from "./Modal/TotalPnlReportsModal/index";
import _ from "lodash";
const today = moment().format("YYYY-MM-DD");

export default function Tab1() {
	const [invoices, setInvoices] = useState([]);
	const [dailyAvargeInvoices, setDailyAvargeInvoices] = useState([]);
	const [startDate, setStartDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
	const [endDate, setEndDate] = useState(today);
	const [whsInvoices, setWhsInvoices] = useState("");
	const [excelLoading, setExcelLoading] = useState(false);
	const [startDateBestSeller, setStartDateBestSeller] = useState(today);
	const [endDateBestSeller, setEndDateBestSeller] = useState(today);
	const [whsBestSeller, setWhsBestSeller] = useState("");
	const [startDateInvoices, setStartDateInvoices] = useState(today);
	const [endDateInvoices, setEndDateInvoices] = useState(today);
	const [loadindInvoices, setLoadingInvoices] = useState(false);
	const [fdata, setFdata] = useState([]);
	const [ABCData, setABCData] = useState([]);
	const [comingData, setComingData] = useState([]);
	const [itemNameABC, setItemNameABC] = useState("");
	const [abcCategory, setAbcCategory] = useState("");
	const [whsABC, setWhsABC] = useState("");
	const [loading2, setLoading2] = useState(false);
	const [loading3, setLoading3] = useState(false);
	const [currentPageNOAction, setCurrentPageNOAction] = useState(0);
	const [pnlReports, setPnlReports] = useState([]);
	const [loading, setLoading] = useState(false);
	const [hasMoreDataNOAction, setHasMoreDataNOAction] = useState(true);
	const [hasMoreDataABC, setHasMoreDataABC] = useState(true);
	const [currentPageABC, setCurrentPageABC] = useState(0);
	const [noActionItems, setNoActionItems] = useState([]);
	const [whsNoAction, setWhsNoAction] = useState("");
	const [clickedInvoice, setClickedInvoice] = useState(null);
	const [invoiceModal, setInvoiceModal] = useState(false);
	const [expenses, setExpenses] = useState([]);
	const [expenseModal, setExpensesModal] = useState(false);
	const [pageSize] = useState(20);
	const [chartData, setChartData] = useState({
		labels: [
			"2023-01-01",
			"2023-02-01",
			"2023-03-01",
			"2023-04-01",
			"2023-05-01",
			"2023-06-01",
			"2023-07-01",
			"2023-08-01",
			"2023-09-01",
			"2023-10-01",
			"2023-11-01",
			"2023-12-01",
			"2024-01-01",
			"2024-02-01",
			"2024-03-01",
		],
		datasets: [
			{
				label: "Last Month",
				data: [
					1000, 20000, 40000, 34000, 2000, 3000, 2000, 3000, 2000, 3000, 2000, 3000, 3000, 3000,
					3000, 3000,
				],
				fill: true,
				backgroundColor: "rgba(59, 130, 246, 0.2)",
				borderColor: "rgba(59, 130, 246, 1)",
			},
			{
				label: "This Month",
				data: [
					2000, 3000, 3000, 3000, 2000, 3000, 5000, 3200, 5000, 3000, 5000, 3000, 10000, 2000,
					45000,
				],
				fill: true,
				backgroundColor: "rgba(34, 197, 94, 0.2)",
				borderColor: "rgba(34, 197, 94, 1)",
			},
			{
				label: "Next Month",
				data: [
					2000, 3000, 3000, 3000, 2000, 3000, 5000, 3200, 5000, 3000, 5000, 3000, 10000, 2000,
					45000,
				],
				fill: true,
				backgroundColor: "rgba(255, 128, 0, 0.2)",
				borderColor: "rgba(255, 128, 0, 1)",
			},
		],
	});
	const [whsOptions, setWhsOptions] = useState([]);
	const [activeTab, setActiveTab] = useState("tab1");
	const [isTotalInvoiceModalOpen, setIsTotalInvoiceModalOpen] = useState(false);
	const [whsLoading, setWhsLoading] = useState(false);
	const [startDateComing, setStartDateComing] = useState(
		moment().startOf("year").format("YYYY-MM-DD")
	);
	const [endDateComing, setEndDateComing] = useState(today);
	const [itemNameComing, setItemNameComing] = useState("");
	const [whsComing, setWhsComing] = useState("");
	const [loadingComing, setLoadingComing] = useState(false);
	const [statusComingItems, setStatusComingItems] = useState("PurchaseInvoice");
	const [periodCharts, setPeriodCharts] = useState("weekly");
	const [loadingCharts, setLoadingCharts] = useState(false);
	const [salesChartsData, setSalesChartsData] = useState({
		labels: [],
		datasets: [],
	});
	const [expensesChartsData, setExpensesChartsData] = useState({
		labels: [],
		datasets: [],
	});
	const [profitChartsData, setProfitChartsData] = useState({
		labels: [],
		datasets: [],
	});
	const renderContent = () => {
		switch (activeTab) {
			case "tab1":
				return (
					<div className="h-full min-h-full w-full mx-auto min-w-[1000px]  ">
						<h2 className="text-xl font-bold mb-4">{"Line Chart"}</h2>
						{salesChartsData?.datasets?.length > 0 ? (
							<Line data={salesChartsData} options={options} />
						) : (
							<div className="text-lg text-center">No data available</div>
						)}
					</div>
				);
			case "tab2":
				return (
					<div className="h-full min-h-full w-full mx-auto min-w-[1000px]  ">
						<h2 className="text-xl font-bold mb-4">{"Line Chart"}</h2>
						{expensesChartsData?.datasets?.length > 0 ? (
							<Line data={expensesChartsData} options={options} />
						) : (
							<div className="text-lg text-center">No data available</div>
						)}
					</div>
				);
			case "tab3":
				return (
					<>
						<div className="h-full min-h-full w-full mx-auto min-w-[1000px]  ">
							<h2 className="text-xl font-bold mb-4">{"Line Chart"}</h2>
							{profitChartsData?.datasets?.length > 0 ? (
								<Line data={profitChartsData} options={options} />
							) : (
								<div className="text-lg text-center">No data available</div>
							)}
						</div>
					</>
				);
			default:
				return null;
		}
	};

	const options = {
		responsive: true,
		plugins: {
			legend: {
				position: "top",
			},
		},
		scales: {
			x: {
				beginAtZero: true,
			},
			y: {
				beginAtZero: true,
				grid: {
					display: false, // Hides horizontal grid lines
				},
			},
		},
	};

	const colorPairs = [
		{ bg: "transparent", border: "rgb(59, 130, 246)" }, // Blue
		{ bg: "transparent", border: "rgb(220, 38, 38)" }, // Red
		{ bg: "transparent", border: "rgb(16, 185, 129)" }, // Green
		{ bg: "transparent", border: "rgb(245, 158, 11)" }, // Yellow
		{ bg: "transparent", border: "rgb(139, 92, 246)" }, // Purple
		{ bg: "transparent", border: "rgb(236, 72, 153)" }, // Pink
		{ bg: "transparent", border: "rgb(14, 165, 233)" }, // Sky
		{ bg: "transparent", border: "rgb(168, 85, 247)" }, // Violet
		{ bg: "transparent", border: "rgb(251, 146, 60)" }, // Orange
		{ bg: "transparent", border: "rgb(20, 184, 166)" }, // Teal
		{ bg: "transparent", border: "rgb(234, 88, 12)" }, // Orange-Dark
		{ bg: "transparent", border: "rgb(22, 163, 74)" }, // Green-Dark
		{ bg: "transparent", border: "rgb(190, 18, 60)" }, // Rose
		{ bg: "transparent", border: "rgb(79, 70, 229)" }, // Indigo
		{ bg: "transparent", border: "rgb(147, 51, 234)" }, // Purple-Dark
		{ bg: "transparent", border: "rgb(6, 182, 212)" }, // Cyan
		{ bg: "transparent", border: "rgb(202, 138, 4)" }, // Yellow-Dark
		{ bg: "transparent", border: "rgb(124, 58, 237)" }, // Violet-Dark
		{ bg: "transparent", border: "rgb(159, 18, 57)" }, // Ruby
		{ bg: "transparent", border: "rgb(47, 132, 4)" }, // Forest
	];

	useEffect(() => {
		getWarehouses();
	}, []);

	useEffect(() => {
		getInvoices(startDateInvoices, endDateInvoices, whsInvoices);
		getPnlReports(startDateInvoices, endDateInvoices, whsInvoices);
		getDailyAvarageInvoice(whsInvoices);
	}, [startDateInvoices, endDateInvoices, whsInvoices]);

	useEffect(() => {
		getBestsellerItems(startDateBestSeller, endDateBestSeller, whsBestSeller);
	}, [startDateBestSeller, endDateBestSeller, whsBestSeller]);

	useEffect(() => {
		getNoActionItems(currentPageNOAction, pageSize, whsNoAction);
	}, [currentPageNOAction, pageSize, whsNoAction]);

	useEffect(() => {
		getABCReports(itemNameABC, abcCategory, currentPageABC, pageSize, startDate, endDate, whsABC);
	}, [itemNameABC, abcCategory, startDate, endDate, currentPageABC, pageSize, whsABC]);

	useEffect(() => {
		getComingItems(itemNameComing, statusComingItems, startDateComing, endDateComing, whsComing);
	}, [itemNameComing, statusComingItems, startDateComing, endDateComing, whsComing]);

	useEffect(() => {
		getSalesCharts(periodCharts, whsInvoices);
		getExpensesCharts(periodCharts, whsInvoices);
		getProfitCharts(periodCharts, whsInvoices);
	}, [periodCharts, whsInvoices]);

	const getWarehouses = async () => {
		setWhsLoading(true);
		try {
			await api.get("api/marioliva/inventoryitems/warehouses").then((res) => {
				setWhsOptions([
					{
						label: "Umumiy",
						value: "",
					},
					...JSON.parse(res.data)?.map((warehouse) => {
						return {
							label: warehouse.whsName,
							value: warehouse.whsName,
						};
					}),
				]);
			});
		} catch (error) {
			console.error(error.message);
		} finally {
			setWhsLoading(false);
		}
	};

	const getPnlReports = async (startDate, endDate, whs) => {
		try {
			await api
				.get(`api/marioliva/pnlreport?startDate=${startDate}&endDate=${endDate}&whsName=${whs}`)
				.then((res) => {
					const resData = JSON.parse(res.data);
					setPnlReports(resData);
					setExpenses(
						resData
							.filter(
								(cash) =>
									cash.acctName !== "Sotuv" &&
									cash.acctName !== "Yalpi Foyda" &&
									cash.acctName !== "Sof Foyda" &&
									cash.acctName !== "Jami Tannarx" &&
									cash.acctName !== "Jami Sotuv"
							)
							?.map((cash) => cash)
					);
				});
		} catch (error) {
			console.error(error.message);
		}
	};

	const getInvoices = async (startDate, endDate, whs) => {
		setLoadingInvoices(true);
		try {
			await api
				.get(
					`api/marioliva/sales/sotuvlar?startDate=${startDate}&endDate=${endDate}&whsName=${whs}`
				)
				.then((res) => {
					setInvoices(JSON.parse(res.data));
				});
		} catch (error) {
			console.error(error.message);
		} finally {
			setLoadingInvoices(false);
		}
	};

	const getDailyAvarageInvoice = async (whs) => {
		try {
			await api.get(`api/marioliva/invoicesaverage?whsName=${whs}`).then((res) => {
				setDailyAvargeInvoices(JSON.parse(res.data));
			});
		} catch (error) {
			console.error(error.message);
		}
	};

	const getBestsellerItems = async (startDate, endDate, whs) => {
		setLoading2(true);
		try {
			await api
				.get(
					`api/marioliva/bestselleritems/items?startDate=${startDate}&endDate=${endDate}&whsName=${whs}`
				)
				.then((res) => {
					setFdata(JSON.parse(res.data));
				});
		} catch (error) {
			console.error(error.message);
		}
		setLoading2(false);
	};

	const getNoActionItems = async (page, pageSize, whs) => {
		setLoading3(true);
		try {
			await api
				.get(
					`api/marioliva/inventoryitems/no-action-items?whsName=${whs}&pageSize=${pageSize}&pageToken=${page}`
				)
				.then((res) => {
					const formattedData = JSON.parse(res.data);
					const hasMore = formattedData.length === pageSize ? true : false;
					setHasMoreDataNOAction(hasMore);
					setNoActionItems(formattedData);
				});
		} catch (error) {
			console.error(error.message);
		}
		setLoading3(false);
	};

	const getABCReports = async (itmName, abc, page, pageSize, startDate, endDate, whsName) => {
		setLoading(true);
		try {
			// abcCategory=${abc}&
			await api
				.get(
					`api/marioliva/abcreport?abcCategory=${abc}&itemName=${itmName}&startDate=${startDate}&endDate=${endDate}&pageToken=${page}&pageSize=${pageSize}&whsName=${whsName}`
				)
				.then((res) => {
					const formattedData = JSON.parse(res.data);
					const hasMore = formattedData.length === pageSize ? true : false;
					setHasMoreDataABC(hasMore);
					setABCData(formattedData);
				});
		} catch (error) {
			console.error(error.message);
		}
		setLoading(false);
	};

	const getComingItems = async (itmName, status, startDate, endDate, whsName) => {
		setLoadingComing(true);
		try {
			await api
				.get(
					`api/marioliva/upcomingproducts?status=${status}&startDate=${startDate}&endDate=${endDate}&itemName=${itmName}&whsName=${whsName}`
				)
				.then((res) => {
					const formattedData = JSON.parse(res.data);
					setComingData(formattedData);
				});
		} catch (error) {
			console.error(error.message);
		}
		setLoadingComing(false);
	};

	const getSalesCharts = async (period, whsName) => {
		setLoadingCharts(true);

		try {
			const { data } = await api.get(
				`api/marioliva/salescharts?period=${period}&whsName=${whsName}`
			);

			if (!data) {
				throw new Error("No data received from the API");
			}

			const formattedData = JSON.parse(data);

			if (!formattedData || !Array.isArray(formattedData)) {
				throw new Error("Invalid data format received");
			}

			const formattedDates = formattedData
				.map((item) => item?.documentLines?.map((line) => line?.salesDocDate))
				.filter((dates) => dates)
				.flat()
				.filter((date) => date)
				.sort((a, b) => new Date(a) - new Date(b));

			const uniqueDates = Array.from(new Set(formattedDates));

			const datasets = formattedData
				.filter((item) => item?.documentLines)
				.map((item, index) => ({
					label: item.whsName || `Dataset ${index + 1}`,
					data: item.documentLines.map((line) => line?.salesDocTotal || 0),
					fill: true,
					backgroundColor: colorPairs[index].bg,
					borderColor: colorPairs[index].border,
					tension: 0.4,
				}));

			setSalesChartsData({
				labels: uniqueDates,
				datasets: datasets,
			});
		} catch (error) {
			console.error("Error fetching sales data:", error.message);
		} finally {
			setLoadingCharts(false);
		}
	};

	const getExpensesCharts = async (period, whsName) => {
		setLoadingCharts(true);

		try {
			const { data } = await api.get(
				`api/marioliva/expensescharts?period=${period}&whsName=${whsName}`
			);

			if (!data) {
				throw new Error("No data received from the API");
			}

			const formattedData = JSON.parse(data);

			if (!formattedData || !Array.isArray(formattedData)) {
				throw new Error("Invalid data format received");
			}

			const formattedDates = formattedData
				.map((item) => item?.documentLines?.map((line) => line?.expensesDocDate))
				.filter((dates) => dates)
				.flat()
				.filter((date) => date)
				.sort((a, b) => new Date(a) - new Date(b));

			const uniqueDates = Array.from(new Set(formattedDates));

			const datasets = formattedData
				.filter((item) => item?.documentLines)
				.map((item, index) => ({
					label: item.whsName || `Dataset ${index + 1}`,
					data: item.documentLines.map((line) => line?.expensesDocTotal || 0),
					fill: true,
					backgroundColor: colorPairs[index].bg,
					borderColor: colorPairs[index].border,
					tension: 0.4,
				}));

			setExpensesChartsData({
				labels: uniqueDates,
				datasets: datasets,
			});
		} catch (error) {
			console.error("Error fetching sales data:", error.message);
		} finally {
			setLoadingCharts(false);
		}
	};

	const getProfitCharts = async (period, whsName) => {
		setLoadingCharts(true);

		try {
			const { data } = await api.get(
				`api/marioliva/profitscharts?period=${period}&whsName=${whsName}`
			);

			if (!data) {
				throw new Error("No data received from the API");
			}

			const formattedData = JSON.parse(data);

			if (!formattedData || !Array.isArray(formattedData)) {
				throw new Error("Invalid data format received");
			}

			const formattedDates = formattedData
				.map((item) => item?.documentLines?.map((line) => line?.profitsDocDate))
				.filter((dates) => dates)
				.flat()
				.filter((date) => date)
				.sort((a, b) => new Date(a) - new Date(b));

			const uniqueDates = Array.from(new Set(formattedDates));

			const datasets = formattedData
				.filter((item) => item?.documentLines)
				.map((item, index) => ({
					label: item.whsName || `Dataset ${index + 1}`,
					data: item.documentLines.map((line) => line?.profitsDocTotal || 0),
					fill: true,
					backgroundColor: colorPairs[index].bg,
					borderColor: colorPairs[index].border,
					tension: 0.4,
				}));

			setProfitChartsData({
				labels: uniqueDates,
				datasets: datasets,
			});
		} catch (error) {
			console.error("Error fetching sales data:", error.message);
		} finally {
			setLoadingCharts(false);
		}
	};

	const handleInputChangeABC = useCallback((value) => {
		setCurrentPageABC(0);
		setItemNameABC(value);
	}, []);

	const handleComingInputChange = useCallback((value) => {
		setItemNameComing(value);
	}, []);

	const handleSelectChange = (value) => {
		if (value === "kunlik") {
			setStartDateBestSeller(today);
			setEndDateBestSeller(today);
		} else if (value === "haftalik") {
			setStartDateBestSeller(moment().subtract(7, "days").format("YYYY-MM-DD"));
			setEndDateBestSeller(today);
		} else if (value === "oylik") {
			setStartDateBestSeller(moment().startOf("month").format("YYYY-MM-DD"));
			setEndDateBestSeller(today);
		}
	};

	const handleNextPageABC = () => {
		if (hasMoreDataABC) {
			setCurrentPageABC((prevPage) => prevPage + 1);
		}
	};

	const handlePreviousPageABC = () => {
		if (currentPageABC > 0) {
			setCurrentPageABC((prevPage) => prevPage - 1);
		}
	};

	const handleNextPageNOAction = () => {
		if (hasMoreDataNOAction) {
			setCurrentPageNOAction((prevPage) => prevPage + 1);
		}
	};

	const handlePreviousPageNOAction = () => {
		if (currentPageNOAction > 0) {
			setCurrentPageNOAction((prevPage) => prevPage - 1);
		}
	};

	const handleExportExcel = async () => {
		setExcelLoading(true);
		try {
			const res = await api.post(
				"api/marioliva/abcreport/export-to-excel",
				{},
				{
					headers: {
						"Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
					},
					responseType: "blob", // Ensure the response is treated as a blob
				}
			);

			const url = window.URL.createObjectURL(
				new Blob([res.data], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				})
			);
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", "ABCKategoriya.xlsx"); // Define the download file name
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} catch (error) {}
		setExcelLoading(false);
	};

	const handleStartDate = (val) => {
		setStartDate(val);
	};

	const handleEndDate = (val) => {
		setEndDate(val);
	};

	const bestSellerColumns = [
		{
			title: "Mahsulot nomi",
			dataIndex: "itemName",
			key: "itemName",
		},
		{
			title: "Mahsulot soni",
			dataIndex: "quantity",
			key: "quantity",
			sorter: (a, b) => a.quantity - b.quantity,
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat("fr-FR").format(text).replace(/\s/g, "  ");

				return `${formattedText}`;
			},
		},
		{
			title: "Mahsulot narxi",
			dataIndex: "price",
			key: "price",
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat("fr-FR").format(text).replace(/\s/g, "  ");

				return `${formattedText}`;
			},
		},
		{
			title: "So'ngi xarid narxi",
			dataIndex: "lastPurPrc",
			key: "lastPurPrc",
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat("fr-FR").format(text).replace(/\s/g, "  ");

				return `${formattedText}`;
			},
		},
		{
			title: "Umumiy foyda",
			dataIndex: "grssProfit",
			key: "grssProfit",
			sorter: (a, b) => a.grssProfit - b.grssProfit,

			render: (text, record) => {
				const formattedText = new Intl.NumberFormat("fr-FR").format(text).replace(/\s/g, "  ");

				return `${formattedText}`;
			},
		},
		{
			title: "O'lchov birligi",
			dataIndex: "salUnitMsr",
			key: "salUnitMsr",
			text: "center",
		},
	];

	const NoActionItemsColumns = [
		{
			title: "Mahsulot nomi",
			dataIndex: "itemName",
			key: "itemName",
		},

		{
			title: "Ombordagi qoldiq",
			dataIndex: "onHand",
			key: "onHand",
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat("fr-FR").format(text).replace(/\s/g, "  ");

				return `${formattedText}`;
			},
		},
		{
			title: "Mahsulot narxi",
			dataIndex: "price",
			key: "price",
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat("fr-FR").format(text).replace(/\s/g, "  ");

				return `${formattedText}`;
			},
		},
		{
			title: "So'ngi xarid  kuni",
			dataIndex: "latestPurchaseDate",
			key: "latestPurchaseDate",
			render: (text, record) => {
				const formattedText = moment(text).format("DD-MM-YYYY");

				return `${formattedText}`;
			},
		},

		{
			title: "Sotuv kunlari soni",
			dataIndex: "u_SalesDays",
			key: "u_SalesDays",
			text: "center",
		},
		{
			title: "Sotilmagan kunlar soni",
			dataIndex: "noSalesDays",
			key: "noSalesDays",
			text: "center",
		},
	];

	const abcColumns = [
		{
			title: "Mahsulot nomi",
			dataIndex: "itemName",
			key: "itemName",
			filterDropdown: ({ confirm, dataIndex }) => (
				<div className="p-2">
					<Input
						placeholder="Mahsulot bo'yicha qidirish"
						value={itemNameABC}
						onChange={(e) => {
							handleInputChangeABC(e.target.value ? e.target.value : "");
							// handleSearch(e, confirm, dataIndex);
						}}
						style={{ width: 200, marginBottom: 8, display: "block" }}
					/>
				</div>
			),
			onFilter: (value, record) => record.itemName === value,
		},

		{
			title: "Miqdori",
			dataIndex: "quantity",
			key: "quantity",
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat("fr-FR").format(text).replace(/\s/g, "  ");

				return `${formattedText}`;
			},
		},
		{
			title: "Savdo summasi",
			dataIndex: "sales",
			key: "sales",
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat("fr-FR").format(text).replace(/\s/g, "  ");

				return `${formattedText}`;
			},
		},
		{
			title: "Savdo foydasi",
			dataIndex: "profit",
			key: "profit",
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat("fr-FR").format(text).replace(/\s/g, "  ");

				return `${formattedText}`;
			},
		},

		{
			title: "Foyda foizda",
			dataIndex: "profitPercent",
			key: "profitPercent",
			text: "center",
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat("fr-FR").format(text);
				return `${formattedText} %`;
			},
		},

		{
			title: "ABC Kategoriya",
			dataIndex: "abcCategory",
			key: "abcCategory",
			filterDropdown: () => (
				<Select
					allowClear
					style={{ width: 150 }}
					placeholder="Select Description"
					value={abcCategory}
					onChange={(value) => {
						setCurrentPageABC(0);
						setAbcCategory(value !== undefined ? value : "");
					}}
				>
					<Select.Option key={""} value={""}>
						Barchasi
					</Select.Option>
					<Select.Option key={"A"} value={"A"}>
						A
					</Select.Option>
					<Select.Option key={"B"} value={"B"}>
						B
					</Select.Option>
					<Select.Option key={"C"} value={"C"}>
						C
					</Select.Option>
				</Select>
			),
			onFilter: (value, record) => record.abcCategory === value,
		},
	];

	const comingItemsColumns = [
		{
			title: "Mahsulot nomi",
			dataIndex: "dscription",
			key: "dscription",
			filterDropdown: ({ confirm, dataIndex }) => (
				<div className="p-2">
					<Input
						placeholder="Mahsulot bo'yicha qidirish"
						onChange={(e) => {
							debouncedSearchComingItems(e.target.value ? e.target.value : "");
						}}
						style={{ width: 200, marginBottom: 8, display: "block" }}
					/>
				</div>
			),
			onFilter: (value, record) => record.itemName === value,
		},

		{
			title: "Miqdori",
			dataIndex: "quantity",
			key: "quantity",
			sorter: (a, b) => a.quantity - b.quantity,
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat("fr-FR").format(text).replace(/\s/g, "  ");

				return `${formattedText}`;
			},
		},
		{
			title: "Yo’lga chiqqan sanasi",
			dataIndex: "docDate",
			key: "docDate",
			// sorter: (a, b) => a.docDate - b.docDate,
			render: (text, record) => {
				const formattedText = moment(text).format("DD-MM-YYYY");

				return `${formattedText}`;
			},
		},
		{
			title: "Qolgan muddat",
			dataIndex: "daysRemaining",
			key: "daysRemaining",
			// sorter: (a, b) => a.daysRemaining - b.daysRemaining,
		},

		{
			title: "Yetib kelish sanasi",
			dataIndex: "docDueDate",
			key: "docDueDate",
			text: "center",
			// sorter: (a, b) => a.docDueDate - b.docDueDate,
			render: (text, record) => {
				const formattedText = moment(text).format("DD-MM-YYYY");
				return `${formattedText} `;
			},
		},
	];

	const statusComingItemsOptions = [
		{
			label: "PurchaseInvoice",
			value: "PurchaseInvoice",
		},
		{
			label: "PurchaseOrder",
			value: "PurchaseOrder",
		},
		{
			label: "GoodsReceipt",
			value: "GoodsReceipt",
		},
	];

	const debouncedSearchComingItems = useCallback(
		_.debounce((value) => {
			setItemNameComing(value);
		}, 500),
		[]
	);

	return (
		<>
			<div className="flex items-center gap-2 sm:gap-8 mt-5">
				<div className="flex flex-col gap-2">
					<p>Boshlang'ich sana</p>
					<Input
						type="date"
						value={startDateInvoices}
						className="w-[150px]"
						onChange={(e) => {
							setStartDateInvoices(e.target.value);
						}}
						max={endDateInvoices}
					/>
				</div>
				<div className="flex flex-col gap-2">
					<p>Tugash sanasi</p>
					<Input
						type="date"
						value={endDateInvoices}
						className="w-[150px]"
						onChange={(e) => {
							setEndDateInvoices(e.target.value);
						}}
						min={startDateInvoices}
						// max={moment}
					/>
				</div>
				<div className="flex flex-col gap-2">
					<p>Do'kon</p>
					<Select
						className="w-[250px]"
						value={whsInvoices}
						onChange={(value) => setWhsInvoices(value)}
						options={whsOptions}
						loading={whsLoading}
					/>
				</div>
			</div>
			{loadindInvoices ? (
				<div className="flex items-center justify-center mt-5">
					<Spin />
				</div>
			) : (
				<>
					<div className="grid grid-cols-1 sm:grid-cols-2  lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 3xl:grid-cols-6  gap-5 mt-5">
						{invoices
							?.filter((invoice) => {
								return whsInvoices === ""
									? invoice.whsName === "Umumiy"
									: invoice.whsName === whsInvoices;
							})
							?.map((invoice, idx) => {
								return (
									<>
										<div
											className="flex h-[120px]  w-full  sm:w-[250px] flex-col gap-4 items-center rounded-3xl bg-white drop-shadow-xl"
											key={idx}
											onClick={() => {
												setIsTotalInvoiceModalOpen(invoice.whsName === "Umumiy" ? true : false);
												setInvoiceModal(invoice.whsName !== "Umumiy" ? true : false);
												setClickedInvoice(invoice);
											}}
										>
											<h1 className="font-poppins  mt-5 text-center text-xl font-bold text-[#425166]">
												{invoice.whsName === "Umumiy" ? "Umumiy Sotuvlar" : invoice.whsName}
											</h1>
											<div>
												<h1 className="font-poppins  text-xl font-bold text-[#151D48]">
													{" "}
													{new Intl.NumberFormat("fr-FR")
														.format(invoice.salesDocTotal)
														.replace(/\s/g, "  ")}{" "}
												</h1>
											</div>
										</div>
									</>
								);
							})}
						{pnlReports
							?.filter(
								(cash) =>
									(cash.acctName !== "Sotuv" && cash.acctName === "Yalpi Foyda") ||
									cash.acctName === "Umumiy Chiqimlar"
							)
							?.map((cash, idx) => {
								return (
									<div
										className="flex h-[120px]  w-full  sm:w-[250px] flex-col gap-4 items-center rounded-3xl bg-white drop-shadow-xl"
										onClick={() => {
											setExpensesModal(cash.acctName === "Umumiy Chiqimlar" ? true : false);
										}}
									>
										<h1 className="font-poppins  mt-5 text-xl font-bold text-[#425166]">
											{cash.acctName === "Arrenda do'kon (toshmi)"
												? "Arenda do'kon (toshmi)"
												: cash.acctName === "SofFoyda"
												? "Sof foyda"
												: cash.acctName === "Umumiy Rasxodlar"
												? "Umumiy Chiqimlar"
												: cash.acctName === "Arrenda do'kon (archa)"
												? "Arenda do'kon (archa)"
												: cash.acctName.replace(/rasxod/g, "chiqim")}
										</h1>

										<h1 className="font-poppins  text-xl font-bold text-[#151D48]">
											{new Intl.NumberFormat("fr-FR").format(cash.summa).replace(/\s/g, "  ")}{" "}
										</h1>
									</div>
								);
							})}
						<div className="flex h-[120px] w-full  sm:w-[250px] flex-col gap-3 items-center rounded-3xl bg-white drop-shadow-xl">
							<h1 className="font-poppins  mt-5 text-xl text-center font-bold text-[#425166]">
								Bir kunlik o'rtacha chek
							</h1>

							<h1 className="font-poppins   text-xl font-bold text-[#151D48]">
								{" "}
								{new Intl.NumberFormat("fr-FR")
									.format(dailyAvargeInvoices.averageDocTotal)
									.replace(/\s/g, "  ")}{" "}
							</h1>
						</div>

						<div className="flex flex-col h-[120px] 	 items-center w-full  sm:w-[250px] gap-3 rounded-3xl bg-white drop-shadow-xl">
							<h1 className="font-poppins  mt-5 text-xl text-center font-bold text-[#425166]">
								Bir kunlik sotuvlar soni
							</h1>

							<h1 className="font-poppins   text-xl font-bold text-[#151D48]">
								{" "}
								{new Intl.NumberFormat("fr-FR")
									.format(dailyAvargeInvoices.invoicesCount)
									.replace(/\s/g, "  ")}{" "}
							</h1>
						</div>
					</div>
				</>
			)}

			<div className="mt-10 mb-10 w-full ">
				<Space style={{ marginBottom: 16 }} className="mt-10 ">
					<button
						className={`${
							activeTab === "tab1" ? "text-blue-900 underline underline-offset-8" : ""
						} font-semibold `}
						onClick={() => setActiveTab("tab1")}
					>
						Sotuvlar
					</button>
					<button
						className={`${
							activeTab === "tab2" ? "text-blue-900 underline underline-offset-8" : ""
						} font-semibold ml-3`}
						onClick={() => setActiveTab("tab2")}
					>
						Chiqimlar
					</button>
					<button
						className={`${
							activeTab === "tab3" ? "text-blue-900 underline underline-offset-8" : ""
						} font-semibold ml-3`}
						onClick={() => setActiveTab("tab3")}
					>
						Foyda
					</button>
				</Space>
				<div>
					<Select
						className="flex   items-center  justify-center w-[250px]"
						onChange={(val) => {
							setPeriodCharts(val);
						}}
						loading={loading}
						value={periodCharts}
						options={[
							{
								value: "weekly",
								label: "Haftalik",
							},
							{
								value: "monthly",
								label: "Oylik",
							},
							{
								value: "yearly",
								label: "Yillik",
							},
							{
								value: "twoYears",
								label: "Oldingi yilgi",
							},
						]}
					/>
					<Spin size="large" spinning={loadingCharts}>
						<div className="mt-10 overflow-x-scroll">{renderContent()}</div>
					</Spin>
				</div>
			</div>

			<div className="mt-10">
				<div className="flex items-center gap-5">
					<h1 className="text-xl font-bold">10 ta eng ko'p sotilgan mahsulot</h1>
					<Select
						className="flex   items-center  justify-center w-[250px]"
						onChange={(value) => {
							handleSelectChange(value);
						}}
						defaultValue="kunlik"
					>
						<Select.Option value="kunlik">Kunlik</Select.Option>
						<Select.Option value="haftalik">Haftalik</Select.Option>
						<Select.Option value="oylik">Oylik</Select.Option>
					</Select>

					<Select
						className="w-[250px]"
						value={whsBestSeller}
						onChange={(value) => setWhsBestSeller(value)}
						options={whsOptions}
						loading={whsLoading}
					/>
				</div>

				<div className="overflow-x-scroll">
					<Table
						columns={bestSellerColumns}
						dataSource={fdata}
						pagination={false}
						className="mt-6 w-full "
						bordered
						loading={loading2}
					/>
				</div>
			</div>

			<div className="mt-10 ">
				<div className="flex items-center gap-5">
					<h1 className="text-xl font-bold">Harakatsiz mahsulotlar</h1>
					<Select
						className="w-[250px]"
						value={whsNoAction}
						onChange={(value) => setWhsNoAction(value)}
						options={whsOptions}
						loading={whsLoading}
					/>
				</div>
				<div className="overflow-x-scroll">
					<Table
						columns={NoActionItemsColumns}
						dataSource={noActionItems}
						pagination={false}
						className="mt-6 w-full "
						bordered
						loading={loading3}
					/>
				</div>

				<div className="mb-4 mt-5 flex flex-col justify-between sm:flex-row">
					<div> </div>
					<div className="flex gap-2 items-center sm:mr-10">
						<button
							onClick={handlePreviousPageNOAction}
							disabled={currentPageNOAction === 0}
							className="h-[40px] w-[100px] rounded-2xl bg-gray-300 text-gray-700 disabled:bg-gray-200 disabled:text-gray-400 sm:w-[100px]"
						>
							oldingi
						</button>
						<span>{currentPageNOAction + 1}</span>
						<button
							onClick={handleNextPageNOAction}
							disabled={!hasMoreDataNOAction}
							className="h-[40px] w-[100px] rounded-2xl bg-[#0A4D68] text-white disabled:bg-gray-200 disabled:text-gray-400 sm:w-[100px]"
						>
							keyingi
						</button>
					</div>
				</div>
			</div>

			<div className="mt-10 mb-5 overflow-x-auto">
				<h1 className="text-lg font-semibold">ABC</h1>

				<div className=" mt-5 flex gap-5 items-center justify-between">
					<div className="flex items-center gap-3">
						<div className="flex flex-col gap-2">
							<p>Boshlang'ich sana</p>
							<Input
								type="date"
								value={startDate}
								className="w-[150px]"
								onChange={(e) => {
									handleStartDate(e.target.value);
								}}
								max={endDate}
							/>
						</div>
						<div className="flex flex-col gap-2">
							<p>Tugash sanasi</p>
							<Input
								type="date"
								value={endDate}
								className="w-[150px]"
								onChange={(e) => {
									handleEndDate(e.target.value);
								}}
								min={startDate}
								// max={moment}
							/>
						</div>
						<div className="flex flex-col gap-2">
							<p>Do'kon</p>
							<Select
								className="w-[250px]"
								value={whsABC}
								onChange={(value) => setWhsABC(value)}
								options={whsOptions}
								loading={whsLoading}
							/>
						</div>
					</div>

					<div>
						<Button
							onClick={handleExportExcel}
							loading={excelLoading}
							className="h-12 w-full rounded-3xl bg-[#0A4D68] text-white sm:w-[200px]"
						>
							Excelga ko'chirish
						</Button>
					</div>
				</div>
				<Table
					columns={abcColumns}
					dataSource={ABCData}
					pagination={false}
					className="mt-6 w-full"
					bordered
					loading={loading}
				/>

				<div className="mb-4 mt-5 flex flex-col justify-between sm:flex-row">
					<div> </div>
					<div className="flex gap-2 items-center sm:mr-10">
						<button
							onClick={handlePreviousPageABC}
							disabled={currentPageABC === 0}
							className="h-[40px] w-[100px] rounded-2xl bg-gray-300 text-gray-700 disabled:bg-gray-200 disabled:text-gray-400 sm:w-[100px]"
						>
							oldingi
						</button>
						<span>{currentPageABC + 1}</span>
						<button
							onClick={handleNextPageABC}
							disabled={!hasMoreDataABC}
							className="h-[40px] w-[100px] rounded-2xl bg-[#0A4D68] text-white disabled:bg-gray-200 disabled:text-gray-400 sm:w-[100px]"
						>
							keyingi
						</button>
					</div>
				</div>
			</div>

			<div className="mt-10 mb-5 overflow-x-auto">
				<h1 className="text-lg font-semibold">Keluvchi mahsulotlar</h1>

				<div className=" mt-5 flex gap-5 items-center ">
					<div className="flex flex-col gap-2">
						<p>Boshlang'ich sana</p>
						<Input
							type="date"
							value={startDateComing}
							className="w-[150px]"
							onChange={(e) => {
								setStartDateComing(e.target.value);
							}}
							max={endDateComing}
						/>
					</div>
					<div className="flex flex-col gap-2">
						<p>Tugash sanasi</p>
						<Input
							type="date"
							value={endDateComing}
							className="w-[150px]"
							onChange={(e) => {
								setEndDateComing(e.target.value);
							}}
							min={startDateComing}
						/>
					</div>
					<div className="flex flex-col gap-2">
						<p>Status</p>
						<Select
							className="w-[150px]"
							value={statusComingItems}
							onChange={(value) => setStatusComingItems(value)}
							options={statusComingItemsOptions}
						/>
					</div>
					<div className="flex flex-col gap-2">
						<p>Do'kon</p>
						<Select
							className="w-[250px]"
							value={whsComing}
							onChange={(value) => setWhsComing(value)}
							options={whsOptions}
							loading={whsLoading}
						/>
					</div>
				</div>
				<Table
					columns={comingItemsColumns}
					dataSource={comingData}
					pagination={false}
					className="mt-6 w-full"
					bordered
					loading={loadingComing}
				/>
			</div>

			<OneInvoiceModal
				visible={invoiceModal}
				data={clickedInvoice}
				onClose={() => setInvoiceModal(false)}
			/>

			<TotalPnlReportsModal
				visible={expenseModal}
				data={expenses}
				onClose={() => setExpensesModal(false)}
			/>

			<TotalInvoicesModal
				visible={isTotalInvoiceModalOpen}
				data={invoices}
				onClose={() => {
					setIsTotalInvoiceModalOpen(false);
				}}
			/>
		</>
	);
}
